import React from 'react'
import { ProductListMinimo } from '../components/ProductListMinimo';
import { useMediodiaMenuData, useMediodiaWithSubCategory } from '../data/mediodia';
import { bebida } from '../data/bebida';
import { ProductListMinimoConPrecio } from '../components/ProductListMinimoConPrecio';
import { postre } from '../data/postre';

export const ComidaDay = () => {

    const itemsEntrante = useMediodiaMenuData('Entrante');
    const itemsSushi = useMediodiaMenuData('Sushi');
    const itemsCalientes = useMediodiaMenuData('Calientes');
    const itemsFritos = useMediodiaMenuData('Fritos');
    const itemsVapor = useMediodiaMenuData('Vapor');
    const itemsPlancha = useMediodiaMenuData('Plancha');

    const itemsNigiri = useMediodiaWithSubCategory('Sushi', 'nigiri');
    const itemsMaki   = useMediodiaWithSubCategory('Sushi', 'maki');
    const itemsSashimi = useMediodiaWithSubCategory('Sushi', 'sashimi');
    const itemsUramaki = useMediodiaWithSubCategory('Sushi', 'uramaki');
    const itemsHosofrito = useMediodiaWithSubCategory('Sushi', 'hosofrito');
    const itemsGunkan = useMediodiaWithSubCategory('Sushi', 'gunkan');
    const itemsTemaki = useMediodiaWithSubCategory('Sushi', 'temaki');
    const itemsOtros = useMediodiaWithSubCategory('Sushi', 'otros');

    const itemsBebida = bebida;
    const itemsPostre = postre;
    
  return (
    <div style={{
        backgroundColor: '#FFF',
        color: '#16213D',
        width: '98%',
        marginLeft: '1%',
        marginTop: '1%',
    }}>
        <h1> Entrantes </h1>
        <ProductListMinimo items={itemsEntrante} />

        <h1> Vapor </h1>
        <ProductListMinimo items={itemsVapor} />

        <h1> Fritos </h1>
        <ProductListMinimo items={itemsFritos} />

        <h1> Plancha </h1>
        <ProductListMinimo items={itemsPlancha} />

        <h1> Wok </h1>
        <ProductListMinimo items={itemsCalientes} />
        
        <h1> Nigiri </h1>
        <ProductListMinimo items={itemsNigiri} />

        <h1> Hosomaki </h1>
        <ProductListMinimo items={itemsMaki} />

        <h1> Uramaki </h1>
        <ProductListMinimo items={itemsUramaki} />

        <h1> Hosofrito </h1>
        <ProductListMinimo items={itemsHosofrito} />

        <h1> Gunkan </h1>
        <ProductListMinimo items={itemsGunkan} />

        <h1> Platos especiales </h1>
        <ProductListMinimo items={itemsSashimi.concat(itemsTemaki).concat(itemsOtros)} />

        <h1> Bebida </h1>
        <ProductListMinimoConPrecio items={itemsBebida} />
                
        <h1> Postre </h1>
        <ProductListMinimoConPrecio items={itemsPostre} />
    </div>
  )
}
